export default __webpack_public_path__ + "static/media/mximg9.93fa8a5b.webp";